export {default} from './WalletTile';
